import { Controller } from 'stimulus';

export default class DateRangeComponentController extends Controller {
  static targets = ["start", "end", "startHidden", "endHidden"];

  connect() {
    console.log('DateRangeComponentController connected');
    this.updateHiddenValues();
    this.updateTriggerText();
  }

  selectToday() {
    this.startTarget.value = new Date().toISOString().split('T')[0]
    this.endTarget.value = new Date().toISOString().split('T')[0]
    this.change();
  }

  selectPastWeek() {
    this.startTarget.value = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString().split('T')[0]
    this.endTarget.value = new Date().toISOString().split('T')[0]
    this.change();
  }

  selectPastMonth() {
    this.startTarget.value = new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString().split('T')[0]
    this.endTarget.value = new Date().toISOString().split('T')[0]
    this.change();
  }

  dropMarkers() {
    this.element.closest('[data-controller="search-filter"]')?.querySelectorAll('[data-search-filter-marker]').forEach(node => node.remove());
  }

  clear() {
    // Removing the inputs drops the params from the request; the marker also goes so the filter is not kept visible.
    this.dropMarkers();
    this.startTarget.remove();
    this.endTarget.remove();
    if (this.hasStartHiddenTarget) this.startHiddenTarget.remove();
    if (this.hasEndHiddenTarget) this.endHiddenTarget.remove();
    this.element.closest('form').requestSubmit();
  }

  change() {
    this.updateHiddenValues();
    console.log('DateRangeComponentController change', this.startTarget.value, this.endTarget.value);
    this.updateTriggerText();
    if (!this.startTarget.value && !this.endTarget.value) this.dropMarkers();
    this.element.closest('form').requestSubmit();
  }

  updateHiddenValues() {
      this.startHiddenTarget.value = this.startTarget.value ? `${this.startTarget.value} 00:00:00` : '';
      this.endHiddenTarget.value = this.endTarget.value ? `${this.endTarget.value} 23:59:59` : '';
  }

  updateTriggerText() {
    let triggerText = null;
    if (this.startTarget.value && this.endTarget.value) {
      triggerText = `${this.startTarget.value} - ${this.endTarget.value}`;
    }

    const searchFilterController = this.application.getControllerForElementAndIdentifier(this.element.closest('[data-controller="search-filter"]'), 'search-filter');
    searchFilterController.updateTriggerText(triggerText);
  }
}